/**
 * The shipped user guide, fetched once per page and parsed into entries —
 * `lib/guide-index.ts` for what an entry is and why the guide is the source.
 *
 * Same origin and part of this build (`GUIDE_URL`), so there is no backend to
 * be down; a failure leaves the index empty and the command search simply has
 * no Guide rows, while the agent's tool says the guide could not be read.
 */

import { GUIDE_URL } from "../lib/guide";
import { parseGuide, type GuideEntry } from "../lib/guide-index";

let entries: GuideEntry[] | undefined;
let pending: Promise<GuideEntry[]> | undefined;

/** The guide's entries, fetched on the first call. Rejects only on a failed read. */
export function loadGuideIndex(): Promise<GuideEntry[]> {
  if (entries) return Promise.resolve(entries);
  pending ??= fetch(GUIDE_URL)
    .then((response) => {
      if (!response.ok) throw new Error(`the user guide could not be read (${response.status})`);
      return response.text();
    })
    .then((html) => (entries = parseGuide(html)))
    .finally(() => {
      // A failed read may be retried by the next caller; a good one is kept.
      pending = undefined;
    });
  return pending;
}

/** The entries if they have landed, else `undefined` — the palette's synchronous read. */
export function guideIndex(): readonly GuideEntry[] | undefined {
  return entries;
}
